import React, { useState } from "react";
import { MessagesSquare, ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import VerdantPanel from "./VerdantPanel";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { startTalk } from "../lib/api";

const KEY = "gf.verdant.general";

const StartForm = ({ onStarted }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { onStarted(await startTalk(name.trim(), email.trim())); }
    catch { toast.error("Please check your name and email."); setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-3">
      <p className="text-sm text-slate-600">Tell us who you are so we can send any report or answer card you choose to keep. No photos needed.</p>
      <Input data-testid="talk-first-name" required placeholder="First name" value={name} onChange={(e) => setName(e.target.value)} className="h-12" />
      <Input data-testid="talk-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" />
      <Button data-testid="talk-start-button" type="submit" disabled={busy} className="w-full h-12 rounded-xl bg-[#14532D] hover:bg-[#0F3F22] font-bold">
        {busy && <Loader2 size={16} className="mr-2 animate-spin" />}START TALKING WITH DR. VERDANT</Button>
    </form>
  );
};

export default function TalkWithSpecialist() {
  const [context, setContext] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(KEY)); } catch { return null; }
  });
  const [asking, setAsking] = useState(false);

  const open = () => (context?.session_id ? setContext({ ...context, open: true }) : setAsking(true));
  const started = (r) => {
    const c = { session_id: r.session_id, case_id: r.case_id, mode: "general_question", first_name: r.first_name,
      case_text: "General question from the Talk With a Specialist page. No photos or diagnostic case were submitted; the customer will type their question in the chat." };
    sessionStorage.setItem(KEY, JSON.stringify(c));
    setAsking(false);
    setContext({ ...c, open: true });
  };

  return (
    <>
      <button data-testid="pathway-talk-button" onClick={open}
        className="group sm:col-span-2 relative text-left rounded-3xl p-6 bg-white hover:bg-amber-50 transition-colors border border-white/40 gf-shadow-glow">
        <div className="flex items-start justify-between">
          <div className="h-12 w-12 rounded-2xl bg-amber-100 text-amber-700 grid place-items-center"><MessagesSquare size={24} /></div>
          <ArrowRight size={22} className="text-amber-600 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition" />
        </div>
        <div className="mt-5">
          <div className="text-[11px] uppercase tracking-widest font-bold text-amber-700">Ask Dr. Verdant</div>
          <div className="font-display text-xl font-bold text-[#092C15] mt-1">Talk With a Specialist</div>
          <div className="text-sm text-slate-600 mt-1">Gardening, irrigation, edible gardens, hardscape or outdoor-living questions. No photos needed.</div>
        </div>
      </button>
      <Dialog open={asking} onOpenChange={setAsking}>
        <DialogContent data-testid="talk-start-dialog" className="max-w-sm">
          <DialogTitle>Talk With a Specialist</DialogTitle>
          <StartForm onStarted={started} />
        </DialogContent>
      </Dialog>
      {context?.open && <VerdantPanel context={context} sessionId={context.session_id} onClose={() => setContext({ ...context, open: false })} />}
    </>
  );
}
